.inc-dec-box{border-radius:15px;font-weight:500;border:1px solid #f1f1f1}.inc-dec-box .icon{font-size:.875rem}.inc-dec-box input[type=number]::-webkit-inner-spin-button,.inc-dec-box input[type=number]::-webkit-outer-spin-button{opacity:1}
/*# sourceMappingURL=mo-form.component-4VUFOOHE.css.map */
